// extracted by mini-css-extract-plugin
export var readonly = "_j0-1";
export var star = "_j0-0";